export enum RequestErrors {
    ERR_NOT_FOUND = "ERR_NOT_FOUND",
    ERR_ALREADY_SCHEDULED = "ERR_ALREADY_SCHEDULED",
    ERR_UPDATING = "ERR_UPDATING",
    ERR_CANNOT_DELETE_ASSIGNED = "ERR_CANNOT_DELETE_ASSIGNED",
    ERR_ALREADY_EXISTS = "ERR_ALREADY_EXISTS",
    ERR_EMAIL = "ERR_EMAIL",
    ERR_NOT_USER_MANAGES = "ERR_NOT_USER_MANAGES",
    ERR_VALIDATION_CODE = "ERR_VALIDATION_CODE",
    ERR_NOT_USER_ASSINGS = "ERR_NOT_USER_ASSINGS",
    ERR_CANNOT_CREATE_VISITS = "ERR_CANNOT_CREATE_VISITS",
    ERR_OPTION_GROUP_IN_USE = "ERR_OPTION_GROUP_IN_USE",
    REQUIRE_VALIDATE = "REQUIRE_VALIDATE",
    ERR_NOT_FINALIZED = "ERR_NOT_FINALIZED",
    ERR_USER_WITHOUT_PERMISSIONS = "ERR_USER_WITHOUT_PERMISSIONS",
    ERR_NO_ACTIVE_USER = "ERR_NO_ACTIVE_USER",
    ERR_SOME_QUESTIONNAIRE_IS_STARTED = "ERR_SOME_QUESTIONNAIRE_IS_STARTED",
    ERR_DELETE_QUESTIONNAIRE_MAIN = "ERR_DELETE_QUESTIONNAIRE_MAIN",
    ERR_DELETE_REPORT_FOLIO = "ERR_DELETE_REPORT_FOLIO",
    ACC_NO_REQUIRE_VALIDATE = "ACC_NO_REQUIRE_VALIDATE",
    EVIDENCE_NOT_FOUND = "EVIDENCE_NOT_FOUND",
    VALIDATION_ERROR = "VALIDATION_ERROR",
    ERR_NOT_ANSWERED = "ERR_NOT_ANSWERED",
    ERR_REPORT_FOLIO_REJECTED = "ERR_REPORT_FOLIO_REJECTED",
    ERR_VALIDATION_FILES = "ERR_VALIDATION_FILES",
    ERR_NO_PERMISSIONS = "ERR_NO_PERMISSIONS",
    ERR_VALID_DATE_START = "ERR_VALID_DATE_START",
    ERR_USER_QUESTIONNAIRE_NOT_TO_BE_STARTED = "ERR_USER_QUESTIONNAIRE_NOT_TO_BE_STARTED",
    ERR_USER_NOT_ALLOWED_REASSIGN = "ERR_USER_NOT_ALLOWED_REASSIGN",
    ERR_ALREADY_ANSWERING = "ERR_ALREADY_ANSWERING",
    ERR_ALREADY_ANSWERED = "ERR_ALREADY_ANSWERED",
    ERR_USERNAME_EXIST = "ERR_USERNAME_EXIST",
    REQUIRE_CHANGE_PASS = "REQUIRE_CHANGE_PASS",
    INVALID_USERNAME_TYPE = "INVALID_USERNAME_TYPE",
    'NOT_SECTION' = "NOT_SECTION",
    ERR_NOT_ALLOWED = "ERR_NOT_ALLOWED",
    ERR_UNAUTHORIZED = "ERR_UNAUTHORIZED",
    errBadRequestDailyErrBadRequestDaily = "errBadRequestDailyErrBadRequestDaily",
    errBadRequestWeeklyErrBadRequestWeekly = "errBadRequestWeeklyErrBadRequestWeekly",
    errBadRequestMonthErrBadRequestMonth = "errBadRequestMonthErrBadRequestMonth",
    ERR_BAD_REQUEST_WEEKLY = "ERR_BAD_REQUEST_WEEKLY",
    ERR_BAD_REQUEST_MONTH = "ERR_BAD_REQUEST_MONTH",
    ERR_BAD_REQUEST_DAILY = "ERR_BAD_REQUEST_DAILY",
    ERR_BAD_REQUEST_CYCLICAL = "ERR_BAD_REQUEST_CYCLICAL",
    ERR_CANNOT_CANCELLED_ACTION_PLAN = "ERR_CANNOT_CANCELLED_ACTION_PLAN",
    ERR_ACTION_PLAN_APPROVERS_NOT_FOUND = "ERR_ACTION_PLAN_APPROVERS_NOT_FOUND",
    ERR_REASSIGNED_REPORT_FOLIO = "ERR_REASSIGNED_REPORT_FOLIO",
    ERR_AUTH = "ERR_AUTH",
    ERR_DUPLICATE_FOLIO = "01",
    ERR_NOT_HAVE_CONFIGURATION = "02",
    ERR_VISIT_NOT_CREATED = "ERR_VISIT_NOT_CREATED",
    ERR_LIMIT_EXCEEDED = "ERR_LIMIT_EXCEEDED",
    ERR_ACTIVITY_FINISHED = "ERR_ACTIVITY_FINISHED",
    ERR_DATE_OUT_LESSER = "ERR_DATE_OUT_LESSER",
    ERR_DATE_OUT_RANGE = "ERR_DATE_OUT_RANGE",
    ERR_SCHEDULE_VISIT = "ERR_SCHEDULE_VISIT",
    ERR_SCHEDULE_OUT_RANGE = "ERR_SCHEDULE_OUT_RANGE",
    ERR_NOT_ALLOWED_DELETE_FILE= "ERR_NOT_ALLOWED_DELETE_FILE",
    ERR_NOT_FOUND_FILE = "ERR_NOT_FOUND_FILE",
    ERR_NOT_ALLOWED_UPDATE_FILE = "ERR_NOT_ALLOWED_UPDATE_FILE",
    LIST_NOT_FOUND = "LIST_NOT_FOUND",
    DUPLICATE_LIST_NAME = "DUPLICATE_LIST_NAME",
    INVALID_OPTIONS = "INVALID_OPTIONS",
    DUPLICATE_OPTIONS = "DUPLICATE_OPTIONS",
    LIST_CANNOT_BE_EMPTY = "LIST_CANNOT_BE_EMPTY",
}